import BloodPressureModal from "./index";

export default function BloodPressureModalExamples() {
  return <BloodPressureModal />;
}
